import React, { useRef, useState, useEffect } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import Mask from "../../../../components/mask/index"
import DisplayTransition from "../../../../components/transitions/display-transition"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Iconfont } from "../../../../../components/icon/iconfont";
import { fetchBeautyLookItem } from "../../../../../../api";
import BeautyProduct from "../../module/beauty-product";

const BeautyLooksItem = props => {
    useStyles(classes);
    const { beautyLook, beautyLooks, onClose } = props;
    const [beautyItem, setBeautyItem] = useState(null);

    useEffect(async () => {
        if(beautyLook?.id){
            setBeautyItem(null);
            let response = await fetchBeautyLookItem(beautyLook?.id).then((data) => data.result).catch((e) => {
                console.log("e", e.result)
                return null;
            });
            setBeautyItem(response);
        }
        
    }, [beautyLook?.id]);

    return <div className={classes.BeautyLooksItem}>
        {
            beautyLooks?.length > 1 && beautyLook && <div className={classes.BeautyLookHd}>
                <div className={classes.Container}>
                    <div className={beautyLooks?.length > 1 && beautyLooks[0]?.id === beautyLook.id ? classes.Disabled : ""} onClick={() => props?.onBeautyLook(false)}>
                        <Iconfont className={classes.Icon}>&#xe693;</Iconfont>
                        <span><FormattedMessage id="previous" defaultMessage="Previous" /></span>
                    </div>
                    <div className={beautyLooks?.length > 1 && beautyLooks[beautyLooks.length - 1]?.id === beautyLook.id ? classes.Disabled : ""} onClick={() => props?.onBeautyLook(true)}>
                        <span><FormattedMessage id="next" defaultMessage="Next" /></span>
                        <Iconfont className={classes.Icon}>&#xe694;</Iconfont>
                    </div>
                </div>

                <Iconfont className={classes.CloseIcon} onClick={onClose}>&#xe69a;</Iconfont>
            </div>
        }

        {
            beautyItem ? (<React.Fragment>
                <div className={classes.BeautyLookBd}>
                    <div className={classes.ImageContainer}>
                        <div className={classes.Image} style={{ backgroundImage: `url(${beautyItem?.image})` }}></div>
                    </div>

                    <div className={classes.Container}>
                        <p className={classes.Title}><FormattedMessage id="get_the_look" defaultMessage="Get the look" /></p>
                        <div className={classes.BeautyContainer}>
                            {
                                beautyItem?.products?.map((item, index) => <BeautyProduct product={item} position={index + 1} />)
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>) :
                (
                    <div className={classes.Loading}>
                        <FormattedMessage id="loading" defaultMessage="Loading" />
                    </div>
                )
        }
    </div>
}

const BeautyLooksModal = props => {
    const { beautyLook, onClose } = props;

    return <React.Fragment>
        <DisplayTransition in={!!beautyLook?.id} className={classes.BeautyLooksModal}>
            <div>
                <BeautyLooksItem {...props} />
            </div>
        </DisplayTransition>

        {
            !!beautyLook?.id && <Mask onClick={onClose} />
        }
    </React.Fragment>
}

const ProductBeautyLooks = props =>{
    useStyles(classes);
    const { beautyLooks } = props;
    const global = useSelector((state) => state.global);
    const [beautyLook, setBeautyLook] = useState(null);

    const onBeautyLook = (flag) => {
        let index = beautyLook?.index;
        if (flag) {
            ++index;
        } else {
            --index;
        }
        setBeautyLook({ id: beautyLooks[index]?.id, index: index });
    }

    return <div className={classes.ProductBeautyLooks}>
        <div className={classes.Hd}>
            @{global?.config?.name} <FormattedMessage id="beauty" defaultMessage="Beauty" />
        </div>

        <div className={classes.Bd}>
            <Swiper 
                navigation={{
                    prevEl: '#beauty-looks-prev',
                    nextEl: '#beauty-looks-next',
                    disabledClass:classes.NavigationDisabled
                }} 
                spaceBetween={16}
                slidesPerView="auto"
            >
                {
                    beautyLooks.map((item,index)=>{
                        return <SwiperSlide key={index} className={classes.ImageItem} onClick={()=>setBeautyLook({id:item.id,index})}>
                            <span className={classes.Item} style={{backgroundImage:`url(${item?.image})`}}></span>
                        </SwiperSlide>
                    })
                }

                <span id="beauty-looks-prev" className={classes.Prev}>
                    <Iconfont>&#xe693;</Iconfont>
                </span>
                <span id="beauty-looks-next" className={classes.Next}>
                    <Iconfont>&#xe694;</Iconfont>
                </span>
            </Swiper>
        </div>

        <BeautyLooksModal beautyLooks={beautyLooks} beautyLook={beautyLook} onBeautyLook={onBeautyLook} onClose={()=>setBeautyLook(null)} />
    </div>
}

export default ProductBeautyLooks;